import { render, staticRenderFns } from "./edit-selected-place-modal.vue?vue&type=template&id=1277b70b&scoped=true"
import script from "./edit-selected-place-modal.vue?vue&type=script&lang=js"
export * from "./edit-selected-place-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-selected-place-modal.vue?vue&type=style&index=0&id=1277b70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277b70b",
  null
  
)

export default component.exports